import { FOCUS_RING } from '@/shared/components/pillClasses';

import type { RunView } from '../searchParams';

const OPTIONS: { value: RunView; label: string }[] = [
  { value: 'board', label: 'Board' },
  { value: 'list', label: 'List' },
];

/**
 * Board or list for the run's tasks. The same pressed-button group as
 * the Tasks page's density control (`TaskListDensity`), so the two read as
 * one kind of control; unlike density, the choice lives in the address.
 */
export function RunViewToggle({
  view,
  onChange,
}: {
  view: RunView;
  onChange: (view: RunView) => void;
}) {
  return (
    <div
      role="group"
      aria-label="Tasks view"
      className="border-input inline-flex h-7 shrink-0 items-center gap-0.5 rounded-lg border p-0.5"
    >
      {OPTIONS.map((option) => {
        const pressed = view === option.value;
        return (
          <button
            key={option.value}
            type="button"
            aria-pressed={pressed}
            onClick={() => {
              onChange(option.value);
            }}
            className={`h-full rounded-md px-2.5 text-xs whitespace-nowrap transition-colors ${FOCUS_RING} ${
              pressed
                ? 'bg-muted text-foreground font-medium'
                : 'text-muted-foreground hover:text-foreground'
            }`}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
